class Support {
    constructor(input) {
        this.input = input;
        this.parent = input.closest(".section--promo");
        this.button = this.parent.querySelector("[data-submit-donation]");
        this.textElement = this.parent.querySelector(
            "[data-display-donation-amount]",
        );
        this.init();
    }

    init() {
        this.input.addEventListener("input", this.changeInput.bind(this));
        this.button.addEventListener("click", this.submitDonation.bind(this));
    }

    changeInput(e) {
        const value = e.target.value;
        if (this.textElement) {
            this.textElement.innerHTML = value;
        }
    }

    submitDonation(e) {
        let el = e.currentTarget;
        let amount = this.textElement
            ? this.textElement.textContent
            : this.input.value;
        let url = `${el.dataset.href}?amount=${amount}`;

        location.href = url;
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const inputs = document.querySelectorAll("[data-custom-donation-input]");

    inputs.forEach((input) => {
        new Support(input);
    });
});

export default Support;
